import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import classes from "./Menu.module.css";
import logo from "../../images/logo.png";
import { logout } from "../../redux/reducers/user";
import { removeState } from "../../utils/useLocalStorage";

const Menu = () => {
  const user = useSelector((state) => state.user.value);
  const dispatch = useDispatch();

  return (
    <div className={`${classes.menu} body_container`}>
      <ul>
        <li>
          <img src={logo} alt="atease insurance" />
        </li>
        <li>
          <Link to="/">HOME</Link>
        </li>
        <li>
          <Link to="/services">SERVICES</Link>
        </li>
        <li>
          <Link to="/dashboard">DASHBOARD</Link>
        </li>
        <li>
          <Link to="/about">ABOUT US</Link>
        </li>
        <li>
          <Link to="/contact">CONTACT US</Link>
        </li>
        <li>
          <a
            href="https://dev-ateaseinsurance.pantheonsite.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            OUR BLOG
          </a>
        </li>
        {!user && (
          <li>
            <Link to="/register">REGISTER</Link>
          </li>
        )}
        {!user && (
          <li>
            <span className="button">
              <Link to="/login">LOGIN</Link>
            </span>
          </li>
        )}
        {user && (
          <li>
            <span className="button">
              <Link
                to="/login"
                onClick={() => {
                  dispatch(logout(user));
                  removeState("user");
                }}
              >
                LOGOUT
              </Link>
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Menu;
